export default __webpack_public_path__ + "static/Book-8ba33bbcc339d549bacd6d31d8bff323.svg";